import React from 'react';

import { useAppContext } from '../../common/ui/app-context';
import FeedbackComponent from '../../common/ui/feedback';
import {
	useApplicationMode,
	useCloudId,
	useExperimentConfig,
	usePrimaryProduct,
	useThirdPartyConfigs,
	useUser,
} from '../../controllers/store/bootstrap';

import { getSearchConfig } from './utils/get-search-config';

/**
 * Renders the "Give feedback" button used in the lite-mode search page header.
 *
 * The lite-mode header doesn't render the right rail, so we surface the
 * existing feedback CTA in the header itself. This wrapper resolves all the
 * props the underlying Feedback component needs (cloud id, primary product,
 * user, selected products, etc.) using the same store hooks as the rest of
 * the relay search page so that consumers of `LiteHeader` don't need to plumb
 * this through manually.
 */
export const LiteHeaderFeedbackButton = (): React.JSX.Element => {
	const { queryParams } = useAppContext();
	const [cloudId] = useCloudId();
	const [primaryProduct] = usePrimaryProduct();
	const [experimentConfig] = useExperimentConfig();
	const [thirdPartyConfigs] = useThirdPartyConfigs();
	const [user] = useUser();
	const applicationMode = useApplicationMode();

	const { selectedProducts } = getSearchConfig({
		cloudId: cloudId || '',
		queryParams,
		thirdPartyConfigs,
	});

	return (
		<FeedbackComponent
			cloudId={cloudId}
			primaryProduct={primaryProduct}
			experimentConfig={experimentConfig}
			selectedProducts={selectedProducts}
			user={user}
			applicationMode={applicationMode}
			source="search-page-lite-header"
			appearance="subtle"
		/>
	);
};
